import { jsx as o } from "react/jsx-runtime";
import { ChevronRightIcon as n, ChevronLeftIcon as m } from "../../icons/componentIcons.mjs";
import "../../forms/Button/Button.mjs";
import { IconButton as r } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { iconSizes as t } from "../../../theme/foundations/icons.mjs";
const h = ({ ...i }) => (
  // @ts-expect-error Rendering the iconbutton as a button without a role (parent link has it instead). aria-label will cause an error.
  /* @__PURE__ */ o(
    r,
    {
      as: "div",
      variant: "ghost",
      size: "sm",
      icon: /* @__PURE__ */ o(n, { fontSize: { base: t.sm, md: t.md }, variant: "light" }),
      ...i
    }
  )
), p = ({ ...i }) => (
  // @ts-expect-error Rendering the iconbutton as a button without a role (parent link has it instead). aria-label will cause an error.
  /* @__PURE__ */ o(
    r,
    {
      as: "div",
      variant: "ghost",
      size: "sm",
      icon: /* @__PURE__ */ o(m, { fontSize: { base: t.sm, md: t.md }, variant: "light" }),
      ...i
    }
  )
);
export {
  h as NextLabel,
  p as PreviousLabel
};
